import React from "react";
import { Section, SectionHeading, Reveal } from "./Primitives";
import { PROCESS } from "../../data/content";

export const Process = () => {
  return (
    <Section id="process" glow>
      <SectionHeading overline={PROCESS.overline} title={PROCESS.title} />

      <div className="mt-16 relative">
        {/* vertical spine */}
        <div className="absolute left-[11px] md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-brand/40 via-white/10 to-transparent md:-translate-x-1/2" />

        <div className="space-y-10 md:space-y-0">
          {PROCESS.steps.map((s, i) => (
            <Reveal key={s.no} delay={0.05}>
              <div
                className={`relative pl-10 md:pl-0 md:grid md:grid-cols-2 md:gap-16 md:items-center ${
                  i % 2 === 1 ? "md:[&>*:first-child]:order-2" : ""
                } md:mb-16`}
              >
                {/* dot */}
                <span className="absolute left-0 md:left-1/2 top-1.5 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 flex items-center justify-center h-6 w-6 rounded-full bg-void border border-brand/40 z-10">
                  <span className="h-2 w-2 rounded-full bg-brand shadow-[0_0_12px_rgba(59,130,246,0.8)]" />
                </span>

                <div className={`${i % 2 === 1 ? "md:text-left md:pl-16" : "md:text-right md:pr-16"}`}>
                  <span className="font-heading text-5xl md:text-6xl font-light text-white/[0.08]">{s.no}</span>
                </div>
                <div className={`${i % 2 === 1 ? "md:pr-16 md:text-right" : "md:pl-16"}`}>
                  <h3 className="font-heading text-xl md:text-2xl font-medium text-white">{s.title}</h3>
                  <p className="mt-3 text-sm md:text-base leading-relaxed text-muted-foreground max-w-md md:inline-block">
                    {s.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Process;
